<template>
  <div class="layout-wrapper" v-bind:dir="active_lang.direction || 'ltr'">
    <VCookiesBottom />
    <notifications group="main" />
    <div class="content-wrapper">
      <div class="layout-header">
        <VHeading />
        <VMenu />
      </div>
      <div class="container-full" v-bind:class="{ fullwidth: fullwidth }">
        <slot name="navigation"></slot>
        <VBreadcrumb v-if="showbreadcrumbs" />
        <slot name="title-header">
          <VMainTitle v-if="title">
            <template slot="title">{{ title }}</template>
            <template slot="subtitle">{{ subtitle }}</template>
          </VMainTitle>
        </slot>
        <slot></slot>
      </div>
      <VFooter :tiny="tinyFooter" class="layout-footer" />
      <div class="whatsapp-icon">
        <a target="_blank" :href="helpUrl">
          <img src="@/static/social/whatsapp.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import VHeading from "@/components/TheHeading";
import VFooter from "@/components/TheFooter";
import VBreadcrumb from "@/components/TheBreadcrumb";
import VMenu from "@/components/navigation/CategoriesNav";
import VCookiesBottom from "@/components/VCookiesBottom";
import VMainTitle from "@/components/VMainTitle";

import { mapState } from "vuex";

export default {
  name: "default-layout",
  props: {
    // a string to be used in v-if to determine wich navigation should be showed
    navigation: String,
    title: String,
    subtitle: String,
    showButtonReturn: {
      default: false,
      type: Boolean,
    },
    showButtonHome: {
      default: false,
      type: Boolean,
    },
    showbreadcrumbs: {
      default: true,
      type: Boolean,
    },
    showButtonBack: {
      default: false,
      type: Boolean,
    },
    tinyFooter: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      pt_uuid: this.$route.params.pt_uuid,
      fullwidth: false,
      helpUrl: "https://api.whatsapp.com/send?phone=" + this.$phoneHelp,
    };
  },
  computed: {
    ...mapState({
      active_lang: state => state.i18nmap.active_lang,
    }),
  },
  methods: {
    // logout() {
    //   this.$store.dispatch('auth/logout');
    // },
  },
  components: {
    VHeading,
    VFooter,
    VBreadcrumb,
    VMenu,
    VCookiesBottom,
    VMainTitle,
  },
  fallbackI18n: {
    messages: {
      und: {
        default: {
          return: "Return",
          home: "Home",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.container-full {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  padding-top: $spacing;
  max-width: $content-max-width;
  position: relative;
  margin: 0 auto;
}

.fullwidth {
  max-width: none;
  width: 100%;
}

.layout-header {
  width: 90%;
  max-width: $content-max-width;
  position: relative;
  margin: 0 auto;
}
body,
#app,
.layout-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content-wrapper {
  flex: 1 0 auto;
  padding-bottom: 1rem;
}

.layout-footer {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  padding-top: $spacing;
  max-width: $content-max-width;
  position: relative;
  margin: 0 auto;
}

@include media-breakpoint-down(md) {
  .notifications {
    width: 100% !important;
  }
}

@include media-breakpoint-down(sm) {
  .container-full {
    padding-top: 0px;
  }
  .title-page {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
}

.whatsapp-icon {
  font-size: 4rem;
  display: scroll;
  position: fixed;
  bottom: 3rem;
  right: 2rem;
  transition: transform 0.2s;
  z-index: 21;
}

.whatsapp-icon:hover {
  transform: scale(
    1.5
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.whatsapp-icon img {
  width: 8rem;
}
</style>
